// src/universal/graphql/errors/index.ts
var graphqlErrors = (error) => {
  var _a;
  const errors = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.errors;
  return Array.isArray(errors) ? errors.map((error2) => {
    var _a2;
    return (_a2 = error2 == null ? void 0 : error2.extensions) == null ? void 0 : _a2.code;
  }) : [];
};
var isTokenExpired = (error) => {
  const errorCodes = graphqlErrors(error);
  return errorCodes.includes("invalid-jwt");
};

export { isTokenExpired };
//# sourceMappingURL=chunk-F2DE7PYR.mjs.map
//# sourceMappingURL=chunk-F2DE7PYR.mjs.map